import { systemGeneratedApplicantStatusReasonLabels, userGeneratedApplicantStatusReasonLabels } from 'apply-data';
import { ApplicantStatusReason } from 'api-paths-cas';

export function getStatusReasonLabel(statusReason: string): string {
  return (
    systemGeneratedApplicantStatusReasonLabels[statusReason] ??
    userGeneratedApplicantStatusReasonLabels[statusReason] ??
    ApplicantStatusReason.Other
  );
}
